import { Background } from '@frontend/Colours';
import { IFrontendServiceContainer } from '../service-container';
export type IFrontentUtilities = ReturnType<typeof util_factory>;

export const util_factory = ({ settings }: IFrontendServiceContainer) => ({
    dark_mode_enabled(): boolean {
        return settings.inset || settings.background !== Background.white;
    },

    white_mode_enabled(): boolean {
        return !settings.inset && settings.background === Background.white;
    },
});
